import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { ApiConfig } from "@/config/api.config";
import { ApiHookProps } from '@/@types/api.types';
import { OwnerListResponseDto } from '@/features/owners/types/owners-dto';
import { useAxiosAuth } from '@/hooks/useAxiosAuth';

type Props = {} & ApiHookProps;

export const useNotInvitedOwnersListApi = ({}: Props = {}) => {
    const axiosInstance = useAxiosAuth();

    const {
        data: notInvitedOwnersListData, 
        isLoading: isLoadingNotInvitedOwnersListData, 
        isError: isErrorNotInvitedOwnersListData
    } = useQuery({
        queryKey: [ ApiConfig.queries.features.owners.queryKeys.notInvitedOwnersList ],
        queryFn: async (): Promise<OwnerListResponseDto> => {
            const url = ApiConfig.queries.features.owners.endpoints.notInvitedOwnersList;
            const response = await axiosInstance.get<OwnerListResponseDto>(url);
            return response.data;
        },
        placeholderData: keepPreviousData
    });

    return {
        notInvitedOwnersListData,
        isLoadingNotInvitedOwnersListData,
        isErrorNotInvitedOwnersListData,   
    }
}